module.exports = __webpack_public_path__ + "img/mono_19.ae56e7b3.png";